import { Height } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import TagComp from '../../Tag/TagComp';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../../Action';

export default function Tags({data}) {
    const trendingState = useSelector(state=>state.trending);
    const dispatch = useDispatch();
    const {getkeyTagPayload} = bindActionCreators(Actions, dispatch)
    const containerStyle={
        border:'1px solid #F6F7F8',
        marginBlock:'10px',
        borderRadius:'6px',
        background:'#F6F7F8',
        padding:'12px',
        minHeight:'48px',
        display:'flex',
        alignItems:'center',
        flexWrap:'wrap'
    }
    const textStyles = {
        fontSize: "14px",
        color: "#2A364A",
        lineHeight: "22px",
        fontWeight: "300",
        display:'flex',
      };
      const [tags, setTags] = useState([]);
    useEffect(()=>{
        if(trendingState.keytagsData[data.origQuestionUuid] !== undefined){
            setTags(trendingState.keytagsData[data.origQuestionUuid].filter(tag=>tag.clickable))
        }
    },[trendingState.keytagsData]);
    
    const onClickTag = (dt)=>{
        let filteredData = tags.filter((tag=>{
            return tag.term===dt;
        }));
        getkeyTagPayload({tag:filteredData[0].term,key:'expert'});
    }
    // console.log("domain data",data)
  return (
    <>
    {
        data?.domain!==undefined ?  <div style={containerStyle} >
        {data?.domain !== undefined && <div style={textStyles}>Domains&nbsp; <TagComp title={data?.domain} />&nbsp;&nbsp;</div>}
        {tags.length!== 0 && <div style={textStyles}>Tags&nbsp; {tags.map(tag=>{
            if(tag.clickable){
                return <TagComp key={tag.term} title={tag.term}  />
            }
        })}</div>
        }
    </div>:<div style={{padding:"12px"}}></div>
    }
   
    </>
  )
}
